import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

i18n
    .use(initReactI18next) // Passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: {
                    startScreen: {
                        title: "Kids Math",
                        kicker: "Daily arithmetic practice",
                        subtitle: "Build a focused set, solve it in calm batches, then review the facts that need another pass.",
                        preview: "Today's set",
                        range: "Range",
                        minutes: "min",
                        noOps: "Choose an operation",
                        minNumber: "Minimum Number",
                        maxNumber: "Maximum Number",
                        equationsCount: "How many problems?",
                        groupSize: "Group size",
                        isNegativeAllowed: "Allow negative results",
                        isGeneratingCombinations: "Generate complementing operations",
                        ops: "Operations",
                        advanced: "Advanced",
                        op: {
                            add: "Addition",
                            sub: "Subtraction",
                            mul: "Multiplication",
                            div: "Division"
                        },
                        opShort: {
                            addition: "add",
                            subtraction: "subtract",
                            multiplication: "multiply",
                            division: "divide"
                        },
                        solve: "Start Solving",
                        print: "Print Exercises",
                    },
                    equations: {
                        next: 'Next',
                        previous: 'Previous',
                        finish: 'Finish',
                        group: 'Group',
                    },
                    review: {
                        title: 'Review Answers',
                        of: 'of',
                        correct: 'correct',
                        score: 'score',
                        answer: 'answer',
                        back: 'Back to Start'
                    }
                }
            },
            de: {
                translation: {
                    startScreen: {
                        title: "Kinder Mathe",
                        kicker: "Tägliches Kopfrechnen",
                        subtitle: "Erstelle eine klare Übungsrunde, löse sie in ruhigen Gruppen und sieh danach sofort, was noch Übung braucht.",
                        preview: "Heutige Runde",
                        range: "Bereich",
                        minutes: "Min.",
                        noOps: "Operation wählen",
                        minNumber: "Minimale Zahl",
                        maxNumber: "Maximale Zahl",
                        equationsCount: "Wie viele Aufgaben?",
                        groupSize: "Gruppengröße",
                        isNegativeAllowed: "Negative Ergebnisse zulassen",
                        isGeneratingCombinations: "Ergänzende Operationen generieren",
                        ops: "Operationen",
                        advanced: "Erweitert",
                        op: {
                            add: "Addition",
                            sub: "Subtraktion",
                            mul: "Multiplikation",
                            div: "Division"
                        },
                        opShort: {
                            addition: "plus",
                            subtraction: "minus",
                            multiplication: "mal",
                            division: "geteilt"
                        },
                        solve: "Mit dem Lösen beginnen",
                        print: "Aufgaben drucken",
                    },
                    equations: {
                        next: 'Weiter',
                        previous: 'Zurück',
                        finish: 'Fertig',
                        group: 'Gruppe',
                    },
                    review: {
                        title: 'Antworten überprüfen',
                        of: 'von',
                        correct: 'richtig',
                        score: 'Punkte',
                        answer: 'Lösung',
                        back: 'Zurück zum Start'
                    }
                }
            }
        },
        lng: "de", // Default language
        fallbackLng: "en",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
